import { WebMenuNode } from '../../../../com/ibm/tw/commons/beans/web.menu.node';
import { B2cLoginViewForm } from '../../../../com/ibm/tw/commons/mvc/b2c.login.viewform';
import { Combo } from 'ui-components/common';

/**
 * 	服務總覽 ViewForm
 *
 * @author Benny
 * @version 1.0, 2017/09/11
 * @see
 * @since
 */
export class CcmotviewHomeViewForm extends B2cLoginViewForm {

    headerTitle: string;

    /**
     * 可選的地區清單
     */
    areaCombo: Combo;

    /**
     * 目前選擇的Area
     */
    selectArea: string;

    /**
     * 選單清單
     */
    webMenuNodeList: WebMenuNode[];

    /** 目前的地區選單 */
    currentMenuNode: WebMenuNode;

}
